export const baseClass = 'carousel';
export const baseClassWithNavModifierClass = `${baseClass}--with-nav`;

export const scrollWrapClass = `${baseClass}__scroll-wrap`;
export const scrollerClass = `${baseClass}__scroller`;
export const scrollerHasNavModifier = `${scrollerClass}--has-nav`;

export const itemWrapClass = `${baseClass}__item-wrap`;
export const itemWrapSelectedClass = `${itemWrapClass}--selected`;

export const itemWrapPrerenderedClass = `${baseClass}__item-wrap-prerendered`;
export const itemWrapPrerenderedSelectedClass = `${itemWrapPrerenderedClass}--selected`;

export const itemClass = `${baseClass}__item`;
export const itemSelectedMarkClass = `${baseClass}__item-selected-mark`;
export const baseMaskClass = `${baseClass}__mask`;

export const navWrapClass = `${baseClass}__nav`;
export const navWrapInHeadModifierClass = `${navWrapClass}__nav--in-header`;
export const navLeftClass = `${baseClass}__nav-left`;
export const navRightClass = `${baseClass}__nav-right`;
export const bbIconClass = 'bb-icon bb-icon--orange-dropdown';
